import Vue from 'vue'
import ToastComponent from '@/components/Toast.vue'

const ToastConstructor = Vue.extend(ToastComponent)

let instance = null

const Toast = {
  install(Vue) {
    Vue.prototype.$toast = function(message, duration = 2000) {
      if (!instance) {
        instance = new ToastConstructor()
        instance.$mount()
        document.body.appendChild(instance.$el)
      }
      instance.show(message, duration)
    }
  }
}

export default Toast
